import { Box, Checkbox, Collapse, FormControlLabel, Typography } from "@mui/material";
import Grid from "@mui/material/Grid/Grid";
import { useState } from "react";
import Form, { FormDirty, FormErrors, FormFooterAllButtons } from "../../../../components/FormControl/Form/Form";
import Panel from "../../../../components/Panel/Panel";
import PanelBodyFormContent from "../../../../components/Panel/PanelBodyFormContent";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';

export interface PermissionItem {
    id: string;
    name: string;
    children?: PermissionItem[];
}

// Grupo: Administração (itens diretos do admin)
export const ADMIN_ITEMS: PermissionItem[] = [
    { id: 'admin.integrators', name: 'Integradores / Clientes' },
    { id: 'admin.finalCustomers', name: 'Clientes finais' },
    { id: 'admin.departments', name: 'Departamentos' },
    { id: 'admin.software', name: 'Software' },
    { id: 'admin.users', name: 'Usuários' },
    {
        id: 'admin.inventory', name: 'Inventário Commbox', children: [
            { id: 'admin.equipaments', name: 'Equipamentos' },
            { id: 'admin.equipamentTypes', name: 'Tipos de equipamento' },
            { id: 'admin.equipamentSituations', name: 'Situações de equipamento' },
            { id: 'admin.equipamentCategories', name: 'Categorias de equipamento' },
            { id: 'admin.localities', name: 'Localidades' },
            { id: 'admin.manufacturers', name: 'Fabricantes' }
        ]
    },
    {
        id: 'admin.documentation', name: 'Documentação', children: [
            { id: 'admin.documentCategories', name: 'Categorias' },
            { id: 'admin.documents', name: 'Documentos' },
            { id: 'admin.documentVersions', name: 'Versões de documentos' }
        ]
    }
];

// Grupo: Configuração
export const CONFIG_ITEMS: PermissionItem[] = [
    { id: 'admin.iaConfigs', name: 'Configurações IA' },
    { id: 'admin.processes', name: 'Processos' },
    { id: 'admin.isoProcesses', name: 'Processos ISO' },
    {
        id: 'admin.ocurrences', name: 'Ocorrências', children: [
            { id: 'admin.ocurrenceTypes', name: 'Tipos de ocorrência' },
            { id: 'admin.ocurrenceOrigins', name: 'Origens da ocorrência' }
        ]
    },
    {
        id: 'admin.techAssistance', name: 'Assistência Técnica', children: [
            { id: 'admin.charges', name: 'Cobranças' },
            { id: 'admin.components', name: 'Componentes' },
            { id: 'admin.damagedCircuitBlocks', name: 'Blocos de circuitos avariados' },
            { id: 'admin.relatedProblems', name: 'Problemas relacionados' }
        ]
    },
    {
        id: 'admin.ticket', name: 'Chamado', children: [
            { id: 'admin.configTicketRegistCustomer', name: 'Configuração do cadastro por cliente' },
            { id: 'admin.configPriorityTimeTask', name: 'Configuração de tempo para atendimento por prioridade' },
            { id: 'admin.checklists', name: 'Checklist' },
            { id: 'admin.textTemplates', name: 'Templates de texto' },
            { id: 'admin.ticketSolutionTypes', name: 'Tipos de solução do ticket' },
            { id: 'admin.ticketLayoutTypes', name: 'Tipos de layout de ticket' },
            { id: 'admin.ticketTypes', name: 'Tipos de ticket' }
        ]
    },
    {
        id: 'admin.email', name: 'Email', children: [
            { id: 'admin.technicalAssistanceEmailConfig', name: 'Emails assistências' },
            { id: 'admin.taskEmailConfig', name: 'Emails chamados' },
            { id: 'admin.emailServer', name: 'Servidor de email' }
        ]
    },
    {
        id: 'admin.receivedOrders', name: 'Encomendas recebidas', children: [
            { id: 'admin.deliveryTypes', name: 'Tipos de entrega' },
            { id: 'admin.packageTypes', name: 'Tipos de pacote' }
        ]
    },
    {
        id: 'admin.general', name: 'Geral', children: [
            { id: 'admin.systemAttachments', name: 'Anexos do sistema' },
            { id: 'admin.ticketCauses', name: 'Causas do ticket' },
            { id: 'admin.ticketRootCauses', name: 'Causas raiz do ticket' },
            { id: 'admin.productLines', name: 'Linhas de produtos' },
            { id: 'admin.ticketOrigins', name: 'Origens do ticket' },
            { id: 'admin.products', name: 'Produtos' },
            { id: 'admin.ticketStatus', name: 'Status do ticket' }
        ]
    },
    {
        id: 'admin.production', name: 'Produção', children: [
            { id: 'admin.nonConformityTypes', name: 'Tipos de não conformidades' },
            { id: 'admin.nonConformityProcedures', name: 'Procedimentos de não conformidades' }
        ]
    }
];

// Grupo: Geral
export const GENERAL_ITEMS: PermissionItem[] = [
    { id: 'admin.certifications', name: 'Certificações' }
];

// Grupo: Comercial (licenciamento)
export const COMMERCIAL_ITEMS: PermissionItem[] = [
    { id: 'admin.licenses', name: 'Licenças' },
    { id: 'admin.licenseTypes', name: 'Tipos de licença' }
];

// Grupo: Relatórios
export const REPORT_ITEMS: PermissionItem[] = [
    { id: 'report.emailProcess', name: 'Envio de emails' },
    {
        id: 'report.techAssistance', name: 'Assistência técnica', children: [
            { id: 'report.techAssisProd', name: 'Assistências por produto' },
            { id: 'report.techAssisProdCirc', name: 'Assistências por produto/circuito' }
        ]
    },
    {
        id: 'report.production', name: 'Produção', children: [
            { id: 'report.prodNonConformity', name: 'Não conformidade' }
        ]
    },
    {
        id: 'report.tasks', name: 'Tarefas', children: [
            { id: 'report.commentTaskTime', name: 'Comentários com Registro de Tempo' },
            { id: 'report.projectTime', name: 'Registro de tempo por projeto' },
            { id: 'report.taskBugIndicators', name: 'Indicadores de bugs de chamados' }
        ]
    }
];

// Mantém compatibilidade com código existente
export const ADMINISTRATION_PERMISSIONS: PermissionItem[] = [
    ...ADMIN_ITEMS,
    ...CONFIG_ITEMS,
    ...GENERAL_ITEMS,
    ...COMMERCIAL_ITEMS
];

// Grupo principal: Admin (página de administração)
export const PERMISSION_GROUPS: PermissionItem[] = [
    {
        id: 'admin',
        name: 'Admin',
        children: [
            {
                id: 'admin.group.admin',
                name: 'Administração',
                children: ADMIN_ITEMS
            },
            {
                id: 'admin.group.config',
                name: 'Configuração',
                children: CONFIG_ITEMS
            },
            {
                id: 'admin.group.general',
                name: 'Geral',
                children: GENERAL_ITEMS
            },
            {
                id: 'admin.group.commercial',
                name: 'Comercial',
                children: COMMERCIAL_ITEMS
            }
        ]
    },
    {
        id: 'report',
        name: 'Relatórios',
        children: [
            {
                id: 'report.group.reports',
                name: 'Relatórios',
                children: REPORT_ITEMS
            }
        ]
    }
];

// Retorna apenas os IDs dos itens folha (sem filhos) - não salva IDs de pastas/grupos
export function getLeafPermissionIds(items: PermissionItem[]): string[] {
    const ids: string[] = [];
    for (const item of items) {
        if (item.children && item.children.length > 0) {
            ids.push(...getLeafPermissionIds(item.children));
        } else {
            ids.push(item.id);
        }
    }
    return ids;
}

export function hasPermission(permissions: string[] | null | undefined, permissionId: string): boolean {
    if (!permissions) return false;
    return permissions.includes(permissionId);
}

// Verifica se o usuário tem pelo menos uma permissão de administração
export function hasAnyAdminPermission(permissions: string[] | null | undefined): boolean {
    if (!permissions) return false;
    const allLeafPermissions = getLeafPermissionIds(ADMINISTRATION_PERMISSIONS);
    return allLeafPermissions.some(permId => permissions.includes(permId));
}

// Verifica se o usuário tem pelo menos uma permissão de relatório
export function hasAnyReportPermission(permissions: string[] | null | undefined): boolean {
    if (!permissions) return false;
    const allLeafPermissions = getLeafPermissionIds(REPORT_ITEMS);
    return allLeafPermissions.some(permId => permissions.includes(permId));
}

export interface UserPermissionsFormData {
    permissions: string[];
}

export interface UserPermissionsProps {
    permissions: string[] | null;
    onSubmit: (data: UserPermissionsFormData, isDirty?: boolean, submitType?: string | null) => Promise<any>;
    onCancel: () => void;
    onUndo?: () => void;
}

export default function UserPermissions(props: UserPermissionsProps) {
    const { permissions: initialPermissions, onSubmit, onCancel, onUndo } = props;

    const [isDirty, setDirty] = useState<boolean>(false);
    const [expandedGroups, setExpandedGroups] = useState<Record<string, boolean>>({});

    const initialValues: UserPermissionsFormData = {
        permissions: initialPermissions || []
    };

    function toggleExpanded(groupId: string) {
        setExpandedGroups(prev => {
            const currentValue = prev[groupId] ?? true; // default é true (expandido)
            return { ...prev, [groupId]: !currentValue };
        });
    }

    function isChecked(permissions: string[], id: string): boolean {
        return permissions.includes(id);
    }

    // Para itens sem filhos
    function handleToggleItem(permissions: string[], item: PermissionItem, setFieldValue: (field: 'permissions', value: string[]) => void) {
        if (isChecked(permissions, item.id)) {
            const newPerms = permissions.filter(p => p !== item.id);
            setFieldValue('permissions', newPerms);
        } else {
            const newPerms = [...permissions, item.id];
            setFieldValue('permissions', newPerms);
        }
    }

    // Para grupos com filhos - marca/desmarca todos os filhos folha
    function handleToggleGroup(permissions: string[], group: PermissionItem, setFieldValue: (field: 'permissions', value: string[]) => void) {
        const leafIds = getLeafPermissionIds([group]);

        if (isGroupChecked(permissions, group)) {
            // Desmarcar todos os filhos
            const newPerms = permissions.filter(p => !leafIds.includes(p));
            setFieldValue('permissions', newPerms);
        } else {
            // Marcar todos os filhos
            const newPerms = Array.from(new Set([...permissions, ...leafIds]));
            setFieldValue('permissions', newPerms);
        }
    }

    function isGroupChecked(permissions: string[], group: PermissionItem): boolean {
        if (!group.children || group.children.length === 0) {
            return isChecked(permissions, group.id);
        }
        const leafIds = getLeafPermissionIds([group]);
        return leafIds.every(id => permissions.includes(id));
    }

    function isGroupIndeterminate(permissions: string[], group: PermissionItem): boolean {
        if (!group.children || group.children.length === 0) return false;
        const leafIds = getLeafPermissionIds([group]);
        const checkedCount = leafIds.filter(id => permissions.includes(id)).length;
        return checkedCount > 0 && checkedCount < leafIds.length;
    }

    async function onSubmitHandler(values: UserPermissionsFormData, dirty: FormDirty<UserPermissionsFormData>, errors?: FormErrors<UserPermissionsFormData>, submitType?: string | null) {
        const formIsDirty = Object.values(dirty).reduce((p, c) => p || c, false);
        await onSubmit(values, formIsDirty, submitType);
    }

    function renderPermissionGroup(
        permissions: string[],
        item: PermissionItem,
        setFieldValue: (field: 'permissions', value: string[]) => void
    ) {
        const hasChildren = item.children && item.children.length > 0;
        const isExpanded = expandedGroups[item.id] ?? true;

        if (!hasChildren) {
            // Item simples sem filhos
            return (
                <Grid item xs={12} sm={6} md={4} key={item.id}>
                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={isChecked(permissions, item.id)}
                                onChange={() => handleToggleItem(permissions, item, setFieldValue)}
                                size="small"
                            />
                        }
                        label={<Typography variant="body2">{item.name}</Typography>}
                    />
                </Grid>
            );
        }

        // Grupo com filhos
        return (
            <Grid item xs={12} key={item.id}>
                <Box
                    sx={{
                        border: '1px solid',
                        borderColor: 'divider',
                        borderRadius: 1,
                        marginBottom: 1,
                        overflow: 'hidden'
                    }}
                >
                    <Box
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            backgroundColor: 'action.hover',
                            padding: '4px 8px',
                            cursor: 'pointer'
                        }}
                        onClick={() => toggleExpanded(item.id)}
                    >
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={isGroupChecked(permissions, item)}
                                    indeterminate={isGroupIndeterminate(permissions, item)}
                                    onChange={(e) => {
                                        e.stopPropagation();
                                        handleToggleGroup(permissions, item, setFieldValue);
                                    }}
                                    onClick={(e) => e.stopPropagation()}
                                    size="small"
                                />
                            }
                            label={<Typography variant="subtitle2" fontWeight="medium">{item.name}</Typography>}
                            onClick={(e) => e.stopPropagation()}
                        />
                        <Box sx={{ flex: 1 }} />
                        {isExpanded ? <ExpandLessIcon fontSize="small" /> : <ExpandMoreIcon fontSize="small" />}
                    </Box>
                    <Collapse in={isExpanded}>
                        <Box sx={{ padding: 1, paddingLeft: 4 }}>
                            <Grid container spacing={0}>
                                {item.children!.map(child => (
                                    <Grid item xs={12} sm={6} md={4} key={child.id}>
                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    checked={isChecked(permissions, child.id)}
                                                    onChange={() => handleToggleItem(permissions, child, setFieldValue)}
                                                    size="small"
                                                />
                                            }
                                            label={<Typography variant="body2">{child.name}</Typography>}
                                        />
                                    </Grid>
                                ))}
                            </Grid>
                        </Box>
                    </Collapse>
                </Box>
            </Grid>
        );
    }

    return (
        <Form<UserPermissionsFormData>
            initialValues={initialValues}
            onSubmit={onSubmitHandler}
            style={{ overflow: 'auto' }}
            onChange={setDirty}
            enableReinitialize
        >
            {({ values, setFieldValue }) => {
                return (
                    <Panel
                        panelFooterButtons={<FormFooterAllButtons onUndo={onUndo} onBack={onCancel} isDirty={isDirty} />}
                    >
                        <PanelBodyFormContent style={{ overflow: 'auto' }}>
                            {PERMISSION_GROUPS.map(mainGroup => {
                                const isMainGroupExpanded = expandedGroups[mainGroup.id] ?? true;
                                return (
                                    <Box key={mainGroup.id} marginBottom={3}>
                                        {/* Cabeçalho do grupo principal (ex: Admin) */}
                                        <Box
                                            sx={{
                                                backgroundColor: 'primary.dark',
                                                color: 'primary.contrastText',
                                                padding: '12px 16px',
                                                borderRadius: isMainGroupExpanded ? '4px 4px 0 0' : '4px',
                                                display: 'flex',
                                                alignItems: 'center',
                                                cursor: 'pointer'
                                            }}
                                            onClick={() => toggleExpanded(mainGroup.id)}
                                        >
                                            <FormControlLabel
                                                control={
                                                    <Checkbox
                                                        checked={isGroupChecked(values.permissions, mainGroup)}
                                                        indeterminate={isGroupIndeterminate(values.permissions, mainGroup)}
                                                        onChange={(e) => {
                                                            e.stopPropagation();
                                                            handleToggleGroup(values.permissions, mainGroup, setFieldValue);
                                                        }}
                                                        onClick={(e) => e.stopPropagation()}
                                                        size="small"
                                                        sx={{ color: 'primary.contrastText', '&.Mui-checked': { color: 'primary.contrastText' }, '&.MuiCheckbox-indeterminate': { color: 'primary.contrastText' } }}
                                                    />
                                                }
                                                label={<Typography variant="h6" fontWeight="bold">{mainGroup.name}</Typography>}
                                                onClick={(e) => e.stopPropagation()}
                                            />
                                            <Box sx={{ flex: 1 }} />
                                            {isMainGroupExpanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                                        </Box>
                                        
                                        <Collapse in={isMainGroupExpanded}>
                                            <Box
                                                sx={{
                                                    border: '1px solid',
                                                    borderColor: 'divider',
                                                    borderTop: 'none',
                                                    borderRadius: '0 0 4px 4px',
                                                    padding: 2
                                                }}
                                            >
                                                {/* Subgrupos (ex: Administração, Configuração, Geral) */}
                                                {mainGroup.children?.map(subGroup => {
                                                    const isSubGroupExpanded = expandedGroups[subGroup.id] ?? true;
                                                    return (
                                                        <Box key={subGroup.id} marginBottom={2}>
                                                            <Box
                                                                sx={{
                                                                    backgroundColor: 'primary.main',
                                                                    color: 'primary.contrastText',
                                                                    padding: '8px 16px',
                                                                    borderRadius: isSubGroupExpanded ? '4px 4px 0 0' : '4px',
                                                                    display: 'flex',
                                                                    alignItems: 'center',
                                                                    cursor: 'pointer'
                                                                }}
                                                                onClick={() => toggleExpanded(subGroup.id)}
                                                            >
                                                                <FormControlLabel
                                                                    control={
                                                                        <Checkbox
                                                                            checked={isGroupChecked(values.permissions, subGroup)}
                                                                            indeterminate={isGroupIndeterminate(values.permissions, subGroup)}
                                                                            onChange={(e) => {
                                                                                e.stopPropagation();
                                                                                handleToggleGroup(values.permissions, subGroup, setFieldValue);
                                                                            }}
                                                                            onClick={(e) => e.stopPropagation()}
                                                                            size="small"
                                                                            sx={{ color: 'primary.contrastText', '&.Mui-checked': { color: 'primary.contrastText' }, '&.MuiCheckbox-indeterminate': { color: 'primary.contrastText' } }}
                                                                        />
                                                                    }
                                                                    label={<Typography variant="subtitle1" fontWeight="bold">{subGroup.name}</Typography>}
                                                                    onClick={(e) => e.stopPropagation()}
                                                                />
                                                                <Box sx={{ flex: 1 }} />
                                                                {isSubGroupExpanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                                                            </Box>
                                                            <Collapse in={isSubGroupExpanded}>
                                                                <Box
                                                                    sx={{
                                                                        border: '1px solid',
                                                                        borderColor: 'divider',
                                                                        borderTop: 'none',
                                                                        borderRadius: '0 0 4px 4px',
                                                                        padding: 2
                                                                    }}
                                                                >
                                                                    <Grid container spacing={1}>
                                                                        {subGroup.children?.map(item => renderPermissionGroup(values.permissions, item, setFieldValue))}
                                                                    </Grid>
                                                                </Box>
                                                            </Collapse>
                                                        </Box>
                                                    );
                                                })}
                                            </Box>
                                        </Collapse>
                                    </Box>
                                );
                            })}
                        </PanelBodyFormContent>
                    </Panel>
                );
            }}
        </Form>
    );
}
